import {AxiosRequestConfig} from 'axios';

import request from '../../axios';

const getAdCatalog = async (payload: IAdCatalogProps) => {
  const {data}: {data: IAdCatalog[]} = await request.get(
    `/api/v2/store/ad-catalog/`,
    {
      params: payload,
    } as AxiosRequestConfig,
  );
  return data;
};

export default getAdCatalog;
